import hashString from "./hashString";
import getUsersIdentity from "./getUsersIdentity";

const getHashedCustomerId = async () => {
  try {
    const customerId = await getUsersIdentity();
    const hashedId = await hashString(customerId);

    return hashedId || undefined;
  } catch (error) {
    return undefined;
  }
};

export default getHashedCustomerId;
